import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SystemApiService } from '@cv-invision/core';

@Injectable()
export class CIProductsService {

	private readonly BASE_URL = '/utils';

	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {
	}

	/**
	 * GET - Return the list of the form types.
	 */
	getFormTypes(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/forms`);
	}

	/**
	 * GET - Return the list of the origins.
	 */
	getOrigins(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}/class-intelligence/auto-import/source`);
	}
}
